import {initWebComponent} from "@/helpers/web-component-helper";
import {toggleAccordionCollapse} from "@/helpers/bootstrap-accordion-helper";
import {initPopper} from "@/modules/popper";
import {clearLayerSearch} from "@/helpers/layer/menu/layer-search-helper.js";

const template = document.createElement('template');

export class LayerMenuOverviewResetComponent extends HTMLElement{
    constructor(){
        super();

        template.innerHTML =  `
          <button class="btn waves-effect icon-btn popper-header" type="button">
             <span class="fa fa-sync"></span>
             <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                 Terug naar originele catalogus
                <div class="arrow" data-popper-arrow=""></div>
              </div>
          </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            clearLayerSearch()
        })

        initPopper()
    }
}
